<template>
  <div style="padding: 16px">
    <el-form :model="form" ref="form" label-width="120px">
      <el-form-item :label="$t('tree.播放方式')">
        <el-checkbox-group v-model="form.playMode" style="text-align: left;">
          <el-checkbox :label="0" :title="$t('tree.紧急')">{{$t('tree.紧急')}}</el-checkbox>
          <el-checkbox :label="2" :title="$t('tree.显示器显示')">{{$t('tree.显示器显示')}}</el-checkbox>
          <el-checkbox :label="3" :title="$t('tree.语音播报')">{{$t('tree.语音播报')}}</el-checkbox>
          <el-checkbox :label="4" :title="$t('tree.广告屏显示')">{{$t('tree.广告屏显示')}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item :label="$t('tree.信息内容')">
        <el-input v-model="form.messageContent" type="textarea" rows="4" :maxlength="60"
          show-word-limit></el-input>
      </el-form-item>
      <el-form-item v-if="messageTemplates.length" :label="$t('tree.选择模板')">
        <div class="template-list">
          <div v-for="(template, index) in messageTemplates" :key="index"
            class="template-item"
            :class="{ active: form.messageContent === template.content }"
            @click="selectTemplate(template)">
            <span class="template-title">【{{ template.label }}】</span>{{ template.content }}
          </div>
        </div>
      </el-form-item>
      <el-form-item :label="$t('tree.发送结果')">
        <el-input v-model="form.sendResult" disabled></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="submitForm('form')">{{$t('tree.发送')}}</el-button>
        <el-button @click="resetForm('form')">{{$t('tree.重置')}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { queryVideoDeviceNoRecorder } from "@/http/vehicle";
import { messageTemplates } from "@/utils/messageTemplates";
export default {
  props: {
    vehicleInfo: {
      type: Object,
      default: {
        vehicleName: "",
        nodeValue: 0,
      },
    },
  },
  watch: {
    vehicleInfo: {
      handler() {
        console.log("开启视频1");
        this.carNo = this.vehicleInfo.vehicleName;
        this.ManufactureID = this.vehicleInfo.manuID;

        this.checkOpenVideo();
      },
      immediate: true,
    },
  },
  data() {
    return {
      form: {
        playMode: [2, 3],
        messageContent: "",
        sendResult: "",
      },
      messageTemplates,
      deviceNo: "",
    };
  },

  beforeDestroy() {
    this.socketClient.DetachEvent(
      "SINGLEMSGVEL",
      this.socketClient.eventType.onSendInfomationAck
    );
  },
  created() {
    this.socketClient.AttachEvent(
      "SINGLEMSGVEL",
      this.socketClient.eventType.onSendInfomationAck,
      this.onSendInfomationAck
    );
  },
  methods: {
    checkOpenVideo() {
      //通过车号获取车辆的视频编号，如果没有，提示没有，如果有，开启视频
      //有行驶记录仪，不一定有视频设备，
      queryVideoDeviceNoRecorder({
        ManufactureID: this.ManufactureID,
      }).then((res) => {
        // console.log(res);
        if (res.code == 200 && res.data.length > 0 && res.data[0].DeviceNo != "") {
          this.deviceNo = res.data[0].DeviceNo;
          
        }
        else {
          //提示，没有视频设备
          this.$message({
            message: this.$t("tree.该车辆没有配置行驶记录仪设备,请联系销售人员"),
            type: "warning",
          })
        }
      });
      // this.deviceNo="004014000022";
      // 
    },
    selectTemplate(template) {
      this.form.messageContent = template.content;
    },
    DeviceResponseResult(v_params) {
      var resultMsg = "";
      var szResult = v_params.result;
      switch (szResult) {
        case 0:
          resultMsg = "";
          break;
        case 1:
          resultMsg = this.$t("public.Fail");
          break;
        case 2:
          resultMsg = this.$t("deviceresponse.msgError");
          break;
        case 3:
          resultMsg = this.$t("deviceresponse.noSupport");
          break;
        case 0x80:
          resultMsg = this.$t("deviceresponse.offLine");
          break;
        case 0x81:
          resultMsg = this.$t("deviceresponse.noAnswer");
          break;
      }
      return resultMsg;
    },

    onSendInfomationAck(v_params) {
      //消息通知应答
      var resultMsg = this.DeviceResponseResult(v_params);
      if (resultMsg != "") {
        this.form.sendResult = resultMsg;
      } else {
        this.form.sendResult = this.$t("tree.下发成功");
      }
    },
    getMsgPlayType() {
      var msgPlayType = 0;
      var mask = 0;

      this.form.playMode.forEach((element) => {
        mask = 1 << element;
        msgPlayType = msgPlayType | mask;
      });
      console.log(msgPlayType);
      return msgPlayType;
    },
    submitForm(formName) {
      var playType = this.getMsgPlayType(); //消息播放方式
      if (playType == 0) {
        //至少选择一种播放方式
        this.$message.warning(this.$t("tree.请先选择一种播放方式"));
        return;
      }
      if (!this.form.messageContent) {
        this.$message.warning(this.$t("tree.请输入信息内容"));
        return;
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.socketClient.socket.SendInfomation(
            this.deviceNo,
            playType,
            this.form.messageContent
          );
          //websocket信息发送
          this.form.sendResult = this.$t("tree.信息下发中");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
      this.form = {
        playMode: [2, 3],
        messageContent: "",
        sendResult: "",
      };
    },
  },
};
</script>

<style scoped>
.template-list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
}

.template-item {
  cursor: pointer;
  padding: 6px 12px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 13px;
  line-height: 1.5;
  transition: all 0.2s;
  background: #fff;
  max-width: 100%;
}

.template-item:hover {
  border-color: #409eff;
  color: #409eff;
}

.template-item.active {
  border-color: #409eff;
  background-color: #ecf5ff;
  color: #409eff;
}

.template-title {
  font-weight: bold;
}
</style>
